import { Link } from "react-router-dom";
import { useCart } from "../../../../app/context/cart-context/cart-context";

import "./order-button.css";
import { useEffect, useState } from "react";

export const OrderButton = () => {

    const { total } = useCart();

    const [currentTotal, setCurrentTotal] = useState(total);

    useEffect(() => {
        setCurrentTotal(total)
    }, [total])

    return (
        <div className="order-nav-wrap">
            <div className="container d-flex justify-content-between align-items-center">
                <div className="total">
                    <span>До оплати:</span>
                    <span>{currentTotal.toFixed(2)} грн</span>

                </div>
                <div className="order-button-wrap">
                    <Link to={`/shipping`} className="order-button">Доставка</Link>
                </div>
            </div>
        </div>
    )
}